module.exports = __webpack_public_path__ + "img/530a.4282ff10.png";